import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from "react";


function App() {
  useEffect(() => {
    window.location.replace("https://www.myooo.co/");
  }, []);
  return null;
}

export default App;
